import * as React from 'react'

import { FolderPageHeaderDocument, MyDocumentsRouteDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const DocumentsListPage = React.lazy(
  () => import('modules/documents/pages/my_documents/DocumentsListPage')
)
const DocumentViewerPage = React.lazy(() => import('modules/documents/pages/DocumentViewerPage'))
const FolderPage = React.lazy(() => import('modules/documents/pages/my_documents/FolderPage'))
const FolderPageHeader = React.lazy(
  () => import('modules/documents/pages/my_documents/FolderPage/FolderPageHeader')
)
const NewDocumentPage = React.lazy(
  () => import('modules/documents/pages/my_documents/NewDocumentPage')
)
const NewFolderDocumentPage = React.lazy(
  () => import('modules/documents/pages/my_documents/NewFolderDocumentPage')
)
const RedirectToDocumentsPage = React.lazy(
  () => import('modules/documents/pages/my_documents/RedirectToDocumentsPage')
)
const RootPage = React.lazy(() => import('modules/documents/pages/my_documents/RootPage'))

export const myDocumentsRoutes: NavigationRoutesFn = (navigation) => [
  {
    path: navigation.documents.path,
    element: <RootPage />,
    handle: {
      module: 'my_documents',
      meta: ({ watchQuery }) => {
        return watchQuery({
          query: MyDocumentsRouteDocument
        }).map(({ data }) => {
          const route = data?.documents?._policies?.companyManageEmployeesFolders.can
            ? navigation.settings.folders.employees.fullPath()
            : undefined

          return {
            title: i18n.t('sidebar.my_documents'),
            settings: route
          }
        })
      }
    },
    children: [
      {
        index: true,
        element: <RedirectToDocumentsPage />
      },
      {
        path: navigation.documents.list.path,
        element: <DocumentsListPage />,
        children: [
          {
            path: navigation.documents.list.new.path,
            element: <NewDocumentPage />
          },
          {
            path: navigation.documents.list.documentId.path,
            element: <DocumentViewerPage />
          }
        ]
      },
      {
        path: navigation.documents.folderId.path,
        element: <FolderPage />,
        handle: {
          resource: true,
          meta: ({ params, watchQuery, session }) => {
            if (!params['folderId']) return { title: '' }
            return watchQuery({
              query: FolderPageHeaderDocument,
              variables: {
                folderId: Number(params['folderId']),
                employeeId: Number(session?.employee?.id)
              }
            }).map(({ data }) => {
              const employee = data.employees.employee
              const folder = data.documents.foldersConnection.edges[0]?.node
              const title = folder ? folder.name : ''

              const ancestors = data.documents.ancestors.edges
                .map((edge) => edge.node)
                .map((node) => ({
                  id: node.id,
                  title: node.name,
                  to: navigation.documents.folderId.fullPath({ folderId: node.id })
                }))

              return {
                title,
                ancestors,
                headerComponent: folder ? (
                  <FolderPageHeader folder={folder} employee={employee} />
                ) : undefined
              }
            })
          }
        },
        children: [
          {
            path: navigation.documents.folderId.new.path,
            element: <NewFolderDocumentPage />
          },
          {
            path: navigation.documents.folderId.documentId.path,
            element: <DocumentViewerPage />
          }
        ]
      }
    ]
  }
]
